// biome-ignore lint/performance/noBarrelFile: intentional
export {
  type ToSignatureHashErrorType as ToFunctionHashErrorType,
  toSignatureHash as toFunctionHash,
} from './toSignatureHash.js'
